import { render, staticRenderFns } from "./ArticleSimilarHeadlinesSection.vue?vue&type=template&id=5b984f02&scoped=true"
import script from "./ArticleSimilarHeadlinesSection.vue?vue&type=script&lang=ts"
export * from "./ArticleSimilarHeadlinesSection.vue?vue&type=script&lang=ts"
import style0 from "./ArticleSimilarHeadlinesSection.vue?vue&type=style&index=0&id=5b984f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b984f02",
  null
  
)

export default component.exports